"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChainName = exports.useSwitchChain = void 0;
const constants_1 = require("../utils/constants");
function useSwitchChain() {
    const switchChain = (chainName) => {
        if (window.parent) {
            const message = JSON.stringify({
                success: true,
                type: constants_1.eventTypes.switchChain,
                data: { chainName },
            });
            window.parent.postMessage(message, document.referrer);
        }
    };
    return { switchChain };
}
exports.useSwitchChain = useSwitchChain;
function useChainName() {
    const chainName = window.localStorage.getItem(constants_1.TRIA_WALLET_SELECTED_CHAIN);
    return { chainName };
}
exports.useChainName = useChainName;
